import React from 'react';
import ComparingBanner from './children/ComparingBanner';
import WhatMovedMost from './children/WhatMovedMost';
import BlindSpotShrink from './children/BlindSpotShrink';
import StrengthsGrowthMovement from './children/StrengthsGrowthMovement';
import TrendHeatmap from './children/TrendHeatmap';

// The comparison-mode counterpart to ChartWrapper's list: the sections that
// read two rounds against each other rather than one round on its own.
// Same contract as the standard list — pure layout, each section gating its
// own loading/empty state, so this stays unconnected.
const TrendChartWrapper = () => {

    return (
        <>

            <ComparingBanner />
            <WhatMovedMost />
            <BlindSpotShrink />
            <StrengthsGrowthMovement />
            <TrendHeatmap />
        </>
    );
};

export default TrendChartWrapper;
